import type { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';

export const isPublicConfigRequest = (
    config?: Pick<AxiosRequestConfig, 'method' | 'url'>,
): boolean => Boolean(config
    && (config.method ?? 'get').toLowerCase() === 'get'
    && (config.url === '/config' || config.url === 'config'));

/** The feature flags endpoint must load before OIDC restoration completes. */
export const preparePublicConfigRequest = (config: InternalAxiosRequestConfig): boolean => {
    if (!isPublicConfigRequest(config)) return false;
    config.withCredentials = false;
    config.headers.delete('Authorization');
    delete config.auth;
    return true;
};
